<mat-card [ngClass.lt-sm]="{'mat-card-inline-sm': true}">
  <mat-card-content>
    <div class="filter" fxLayoutAlign="center center" fxLayout="row" fxLayoutGap="15px" fxLayout.lt-sm="column">
      <mat-form-field class="accent">
        <mat-label>Search ranges by name</mat-label>
        <input matInput type="text"
          [(ngModel)]="searchTerm"
          (keyup.enter)="loadRanges()"
          (keyup.esc)="searchTerm=''; loadRanges()"
          name="searchTerm"
          placeholder="Search Name">
        <button mat-button *ngIf="searchTerm" matSuffix mat-icon-button aria-label="Clear" (click)="searchTerm=''; loadRanges()">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
      <div fxLayout="row" fxLayoutGap="10px">
        <button
          type="submit"
          mat-flat-button color="primary"
          (click)="loadRanges()"
          matTooltip="Search"
          [class.button-spinner]="loading"
          [disabled]="loading">
          <mat-icon>search</mat-icon> Search
        </button>
      </div>
    </div>
  </mat-card-content>
</mat-card>
<mat-card class="contrast" *ngFor="let item of rangeDataSource.data"
  [class.card-link]="canBeEdited(item)"
  [class.banner-error]="item?.isDeleted"
  [ngClass.lt-sm]="{'mat-card-inline-sm': true}"
  (click)="onClickRange(item)">
  <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
    <div fxFlex="40" fxLayoutAlign="start center" fxLayout="row">
      <strong [ngClass.lt-sm]="{'card-title': true}" [innerHtml]="item?.name | encodeHtml | highlight: searchTerm"></strong>
    </div>
    <div fxFlex="60" fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="0px" fxLayoutGap.lt-sm="18px">
      <div fxFlex="100" fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign.lt-sm="center center" class="date-text">
        <!-- <p><small>products</small>&nbsp;</p>
        <div class="highlight"> {{ item?.rangeRoles?.length }}</div> -->
        <p *ngIf="item?.canShare"><small>partners shared with</small>&nbsp;</p>
        <div *ngIf="item?.canShare" class="text-info">{{ item?.rangeAuthorisedCompanies?.length }}</div>
      </div>
      <!-- <div fxFlex="30" fxLayoutAlign="end center" fxLayout="row" fxLayoutGap="10px">
        <button *ngIf="canBeEdited(item)" mat-mini-fab color="accent" aria-label="Edit Range" matTooltip="Edit Range" (click)="onClickRange(item)">
          <mat-icon>edit</mat-icon>
        </button>
      </div> -->
    </div>
  </mat-card-content>
</mat-card>
<mat-card [ngClass.lt-sm]="{'mat-card-inline-sm': true}">
  <mat-paginator [length]="viewControls.totalItems" [pageSize]="viewControls.pageSize"
    [pageIndex]="viewControls.pageIndex" [pageSizeOptions]="viewControls.pageSizeOptions"
    (page)="onPageChange($event)">
  </mat-paginator>
</mat-card>